import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-inbox-success",
  "use": "icon-inbox-success-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-inbox-success\">\r\n    <path d=\"M4 30L9 6H39L44 30\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n    <path d=\"M4 30H14.9091L16.7273 36H31.2727L33.0909 30H44V43H4V30Z\" fill=\"none\" stroke-width=\"4\" stroke-linejoin=\"round\" />\r\n    <path d=\"M19 19.2143L23 24L31 16\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol